
import { mapGetters } from 'vuex'
import promoData from "@/data/promo.json";
import optionsData from '@/data/options.json';

export default {
  props: {
    // Layout only. 'bar' = top banner (default), 'menu' = mobile menu card.
    variant: {
      type: String,
      default: 'bar',
      validator (v) { return v === 'bar' || v === 'menu' },
    },
  },
  data() {
    return {
      banner: {},
      options: optionsData,
      mountedRegion: null,
      activeCampaign: null,
      countdownVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      detectedRegion: 'geolocation/region',
      userRegion: 'user/region',
    }),
    region(){
      let regionVar =  this.userRegion === 'default' ? this.detectedRegion : this.userRegion
      if(!regionVar){
        if (process.client) {
          regionVar = this.$cookies.get('tefl_geolocation_region');
        }
      }
      return regionVar
    },
    promoRegionData() {
        if (!promoData || !Array.isArray(promoData.regions)) {
            return { standardOffer: {}, specialOffer: {} };
        }

        const normalizedRegionCode = this.region;
        let foundRegion = promoData.regions.find(r => r.code === normalizedRegionCode);

        if (!foundRegion) {
            if (process.client) {
                console.warn(`Region '${this.region}' not found in promoData. Falling back to 'en'.`);
            }
            foundRegion = promoData.regions.find(r => r.code === 'en');
        }

        return foundRegion || { standardOffer: {}, specialOffer: {} };
    },

    // UPDATED FOR NEW CAMPAIGN SYSTEM

    activePromoOffer() {
      if (this.activeCampaign) {
        let rc = (this.region || 'en').toLowerCase().trim()
        if (rc === 'uk') rc = 'en'
        else if (rc === 'us' || rc === 'en_us') rc = 'en-us'
        const co = this.activeCampaign.offerForRegion(rc)
        if (co) return co
      }
      if (this.promoRegionData.specialOffer &&
          this.promoRegionData.specialOffer.enabled &&
          Array.isArray(this.promoRegionData.specialOffer.coursesOnSale) &&
          this.promoRegionData.specialOffer.coursesOnSale.length > 0) {
        return this.promoRegionData.specialOffer
      }
      return this.promoRegionData.standardOffer || {}
    },

    offerLink(){
      return this.activePromoOffer.offerUrl
    },
    offerText(){
      return this.activePromoOffer.offerText
    },
    offerAmount() {
      return this.activePromoOffer.discountAmount || 0;
    },
    // The live campaign's bundle override, or null. Percentage-type only for now
    // (wording assumes "% off"); flatdiscount would need currency formatting.
    bundleOffer() {
      if (this.activeCampaign && this.activeCampaign.bundle && this.activeCampaign.bundle.code) {
        return this.activeCampaign.bundle
      }
      return null
    },
    bundleAmount() {
      return this.bundleOffer ? this.bundleOffer.amount : 0
    },
    // Halloween campaign: yellow banner with black text (see .banner--halloween)
    isHalloween() {
      return !!(this.activeCampaign && this.activeCampaign.slug === 'halloween')
    },
    saleArray(){
      const FPCourses = optionsData.freeproduct_array ? JSON.parse(optionsData.freeproduct_array) : [];
      return FPCourses
    },
    all() {
      if (this.activeCampaign && this.activeCampaign.slug !== 'audio-launch') {
        return 'all'
      }
      if( this.activeCampaign && this.activeCampaign.slug === 'audio-launch') {
        return 'selected'
      }
      if (this.promoRegionData.specialOffer &&
          this.promoRegionData.specialOffer.enabled &&
          Array.isArray(this.promoRegionData.specialOffer.coursesOnSale) &&
          this.promoRegionData.specialOffer.coursesOnSale.length > 0) {
        return 'selected'
      }
      return 'all'
    },
  },
  mounted() {
    if (this.$campaign && this.$campaign.isActive) {
      const offer = this.$campaign.offerForRegion(this.region)
      if (offer && offer.offerText) {
        this.activeCampaign = this.$campaign
      }
    }
  },
};
